import Vue from 'vue';
import approveDashboardUrls from '../../../../urls/approveDashboardUrls';
import manageAppsUrls from '../../../../urls/manageAppsUrls';

export const storePrefix = "apps_budgets_store";

const state = {
    sessionStorageKey: "apps_budgets_key",
    appsList: [],
    isLoading: false,
}

const getters = {
    appsBudgetsList(state) {
        return state.appsList;
    },

    monthlyBudgetLoading(state) {
        return state.isLoading;
    },
}

const mutations = {
    [`${storePrefix}setAppsList`](state, payload) {
        state.appsList = [];
        state.appsList = [...payload];
        //state.appsList = payload;
    },

    [`${storePrefix}setAppsListWithCampaigns`](state) {
        const appsList = [...state.appsList];
        state.appsList = [];
        appsList.forEach((app) => {
            app.activeCampaigns = 0;
            app.currentCost = 0;
        });
        g_res.campaignsData.forEach((campaign) => {
            appsList.forEach((app) => {
                if (campaign._status_type == 0 && campaign.pba_number === app.pbaNumber) {
                    app.activeCampaigns = app.activeCampaigns ? app.activeCampaigns + 1 : 1;
                    app.currentCost = app.currentCost ? app.currentCost + campaign.Cost : campaign.Cost;
                }
            });
        });
        state.appsList = [...appsList];
        //state.appsList = payload;
    },

    [`${storePrefix}setMonthlyBudgetLoading`](state, payload) {
        state.isLoading = payload;
    },
}

const actions = {

    getAppsWithActiveCampaigns(context, { pbId }) {
        return new Promise((resolve, reject) => {
            Vue.$http.post(manageAppsUrls.getAppsWithActiveCampaigns, {
                pbId: pbId,
            })
                .then((res) => {
                    // context.commit(`${storePrefix}setAppsList`, res.data);
                    context.commit(`${storePrefix}setAppsList`, appsList);
                })
                .catch((er) => reject(er));
        });
    },

    saveAppsMonthlyBudget(context, appsBudgetsList) {
        context.commit(`${storePrefix}setMonthlyBudgetLoading`, true);
        $('.loader').show();
        return new Promise((resolve, reject) => {
            Vue.$http.post(approveDashboardUrls.saveAppsMonthlyBudget, {
                appsBudgetsList: appsBudgetsList,
            })
                .then((res) => {
                    const appsList = [...context.state.appsList];
                    appsList.forEach((app) => {
                        appsBudgetsList.forEach((appBudget) => {
                            if (app.pbaNumber === appBudget.pbaNumber) {
                                app.monthlyBudget = +appBudget.monthlyBudget;
                                app.budgetToUse = +appBudget.monthlyBudget - app.usedBudget;
                            }
                        });
                    });

                    context.commit(`${storePrefix}setAppsList`, [...appsList]);
                    resolve(res);
                    context.commit(`${storePrefix}setMonthlyBudgetLoading`, false);
                    setupAppsBudgets();
                    g_filterSort.clientFilter();
                    $('.loader').hide();
                })
                .catch((er) => {
                    reject(er);
                    context.commit(`${storePrefix}setMonthlyBudgetLoading`, false);
                    $('.loader').hide();
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/components/Campaign/AppsBudgets/store/appsBudgets.js